import ErrorPageView from './ErrorPageView';

export default ErrorPageView;
